<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter TableOfContents">
<p id="rw-p_137509-00001"><a id="pb-rw_xiii">
</a></p><a id="pb-rw_xiii">
<div class="title-block" id="rw-title-block_137509-00001">
<h1 style="text-align: center;">TABLE OF CONTENTS</h1>
</div>
</a><div class="block toc" id="rw-block-toc_137509-00001"><a id="pb-rw_xiii">
</a><p><a id="pb-rw_xiii"></a><a href="#/9781847675026_chapter_01#pb-rw_1">The Star</a>
</p>
<p><a href="#/9781847675026_chapter_02#pb-rw_4">The Spread Of Ian Nicol</a>
</p>
<p><a href="#/9781847675026_chapter_03#pb-rw_8">The Problem</a>
</p>
<p><a href="#/9781847675026_chapter_04#pb-rw_11">The Cause Of Some Recent Changes</a>
</p>
<p><a href="#/9781847675026_chapter_05#pb-rw_17">The Comedy Of The White Dog</a>
</p>
<p><span href="#/9781847675026_chapter_06#pb-rw_37" title="Link target outside of Sample">The Crank That Made The Revolution</span>
</p>
<p><span href="#/9781847675026_chapter_07#pb-rw_44" title="Link target outside of Sample">The Great Bear Cult</span>
</p>
<p><span href="#/9781847675026_chapter_08#pb-rw_67" title="Link target outside of Sample">The Start Of The Axletree</span>
</p>
<p><span href="#/9781847675026_chapter_09#pb-rw_85" title="Link target outside of Sample">Five Letters From An Eastern Empire</span>
</p>
<p><span href="#/9781847675026_chapter_10#pb-rw_134" title="Link target outside of Sample">Sir Thomas’s Logopandocy</span>
</p>
<p><span href="#/9781847675026_chapter_11#pb-rw_193" title="Link target outside of Sample">M. Pollard’s Prometheus</span>
</p>
<p><span href="#/9781847675026_chapter_12#pb-rw_229" title="Link target outside of Sample">The End Of The Axletree</span>
</p>
<p><span href="#/9781847675026_chapter_13#pb-rw_268" title="Link target outside of Sample">A Unique Case</span>
</p>
<p><span href="#/9781847675026_chapter_14#pb-rw_271" title="Link target outside of Sample">Inches In A Column</span>
</p>
<p><span href="#/9781847675026_chapter_15#pb-rw_274" title="Link target outside of Sample">A Likely Story Outside A Domestic Setting</span>
</p>
<p><span href="#/9781847675026_chapter_16#pb-rw_275" title="Link target outside of Sample">A Likely Story Within A Domestic Setting</span>
</p>
<p><span href="#/9781847675026_acknowledgements#pb-rw_277" title="Link target outside of Sample">Author’s Acknowledgements</span>
</p>
<p><span href="#/9781847675026_chapter_17#pb-rw_278" title="Link target outside of Sample">Postscript by Author and Douglas Gifford</span>
</p>
</div>
<div style="page-break-after: always;">
<p id="rw-p_137509-00003"><a id="pb-rw_xiv"><br/><br/><br/><br/><br/> 
         </a></p><a id="pb-rw_xiv">
<div class="media image align-center width-auto" id="rw-media-image_137509-00001">
<div class="pc"><img alt="alt" src="xii-1.png"/>
</div>
</div>
</a></div><a id="pb-rw_xiv">
</a></div><a id="pb-rw_xiv">
</a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847675026_tableofcontents.vue?79b07a3d